import React from 'react';
export const TermsOfService = () => {
  return <div className="pt-20" data-id="element-4667">
      <section className="py-16 bg-secondary/5" data-id="element-4668">
        <div className="container mx-auto px-4" data-id="element-4669">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4670">
            Terms of Service
          </h1>
          <p className="text-center text-secondary" data-id="element-4671">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-4672">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-4673">
          <div className="prose prose-lg max-w-none" data-id="element-4674">
            <p data-id="element-4675">
              Welcome to The Networking Salon — a community built on connection,
              trust, and growth. By joining our events, engaging with our
              network, or using our website, you're agreeing to these terms.
              They're here to set clear expectations so everyone can have a
              safe, respectful, and valuable experience.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4676">
              1. Our Promise to You
            </h2>
            <p data-id="element-4677">
              We're here to create spaces — online and offline — where
              meaningful professional relationships can grow. We commit to
              providing a respectful, inclusive, and inspiring environment for
              all our members.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4678">
              2. Your Part in the Community
            </h2>
            <p data-id="element-4679">By being part of The Networking Salon, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4680">
              <li data-id="element-4681">Show up with respect, professionalism, and curiosity.</li>
              <li data-id="element-4682">
                Treat fellow members with kindness, regardless of background,
                role, or opinion.
              </li>
              <li data-id="element-4683">
                Use our events and platforms to build genuine connections, not
                just to pitch or sell.
              </li>
              <li data-id="element-4684">
                Keep confidential conversations private, unless you've been
                given permission to share.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4685">
              3. Event Participation
            </h2>
            <p data-id="element-4686">When you attend our events, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4687">
              <li data-id="element-4688">
                Follow all event guidelines and venue/virtual platform rules.
              </li>
              <li data-id="element-4689">Respect others' time, space, and perspectives.</li>
              <li data-id="element-4690">
                Understand that we may capture photos or videos at events, which
                may be used for promotional purposes (you can opt out in writing
                if you prefer not to be included).
              </li>
            </ul>
            <p data-id="element-4691">
              We reserve the right to remove anyone whose behavior disrupts the
              safe and respectful spirit of the community.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4692">
              4. Payments & Refunds
            </h2>
            <p data-id="element-4693">Some of our events, memberships, or services require payment.</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4694">
              <li data-id="element-4695">
                Unless otherwise stated, tickets and fees are non-refundable,
                but we'll always try to accommodate transfers or credits if life
                gets in the way.
              </li>
              <li data-id="element-4696">
                If we cancel an event, you'll receive a full refund or credit.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4697">
              5. Intellectual Property
            </h2>
            <p data-id="element-4698">
              The Networking Salon's content, branding, and event materials
              belong to us. You're welcome to share what you've learned and
              experienced, but please don't copy or use our materials without
              permission.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4699">
              6. Liability & Expectations
            </h2>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4700">
              <li data-id="element-4701">
                We provide opportunities for connection, but we can't guarantee
                specific outcomes (like business deals or partnerships).
              </li>
              <li data-id="element-4702">
                We are not liable for any loss, damage, or injury connected to
                your participation in our events, website, or services.
              </li>
              <li data-id="element-4703">
                Participation is at your own discretion and responsibility.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4704">
              7. Updates to These Terms
            </h2>
            <p data-id="element-4705">
              We may update these terms occasionally. Any changes will be posted
              on our website, and by continuing to use our services, you agree
              to the updated version.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4706">8. Governing Law</h2>
            <p data-id="element-4707">
              These terms are governed by the laws of Nigeria, and any disputes
              will be resolved in the courts of Lagos.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4708">9. Contact Us</h2>
            <p data-id="element-4709">We're here for questions, clarifications, or feedback.</p>
            <p data-id="element-4710">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-4711">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};